// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  relocationFeatureEnabled: false,
  vouchersFeaturesEnabled: true,
  api_base_urls: {
    ms_defaults: ['dot-magicpallet.ey.r.appspot.com', 'http://localhost'],
    ms_users: 'https://dev-users-dot-magicpallet.ey.r.appspot.com/',
    ms_stocks: 'https://dev-stocks-dot-magicpallet.ey.r.appspot.com/',
    ms_notif: 'https://dev-notif-dot-magicpallet.ey.r.appspot.com/',
    ms_generator: 'https://dev-generator-dot-magicpallet.ey.r.appspot.com/',
    ms_alerting: 'https://dev-alerting-dot-magicpallet.ey.r.appspot.com/',
    ms_data: 'https://dev-data-dot-magicpallet.ey.r.appspot.com/'
  },
  supportedLanguages: [
    'fr',
    'en'
  ],
  auth0Config: {
    tenantUrl: 'https://beta.auth.magicpallet.com',
    clientId: '4FPHYV0SuWJmdS8wBrbPwCr8yRboUzM6',
    scope: 'offline_access openid',
    realm: 'user-with-roles',
    audience: 'https://beta.api.magicpallet.com/pms/'
  },
  firebaseConfig: {
    apiKey: 'AIzaSyD8kxZaFB2aRiJ0RdlkyhbzFHREws0_iho',
    authDomain: 'magicpallet-dev.firebaseapp.com',
    projectId: 'magicpallet-dev',
    storageBucket: 'magicpallet-dev.appspot.com',
    messagingSenderId: '465550931100',
    appId: '1:465550931100:web:165568fe46488e11366959'
  },
  googleAPIKey: 'AIzaSyA2W-l3VpdGfarPFe2iBihHcWQh5N4GEA4',
  cloudStorageHelpURL: 'https://storage.googleapis.com/storage-help-beta-magicpallet/',
  cloudStorageImageURL:
      'https://storage.googleapis.com/dev-storage-file-magicpallet/',
  baseUrl: 'http://localhost:4200',
  stripe: {
    publicApiKey: 'pk_test_yH9KRnppRbXZSMuGZHIygctL'
  },
  protectedAcces: true,
  delayExpirationTickets: {
    // Twenty two days.
    soon: 1900800000,
    // Height days.
    expired: 691200000
  },
  map: {
    bounds: {
      southWest: {
        lat: 36,
        lng: -24
      },
      northEast: {
        lat: 72,
        lng: 66
      },
      strict: true
    }
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
